export default {
  /**
   * Set the Staff List items
   *
   * @param state
   * @param items
   */
  setSchoolLeaveDetailList(state, items) {
    state.items = items;
  },

  /**
   * Set Staff List pagination meta
   *
   * @param state
   * @param pagination
   */
  setSchoolLeaveDetailListPagination(state, pagination) {
    state.pagination = pagination;
  },

  /**
   * Set Staff List current page
   *
   * @param state
   * @param currentPage
   */
  setSchoolLeaveDetailListPage(state, currentPage) {
    state.pagination.current_page = currentPage;
  },

  /**
   * Set state's filters
   *
   * @param state
   * @param filters
   */
  setSchoolLeaveListFilters(state, filters) {
    state.filters = filters;
  },
};
